import { useDispatch } from "react-redux";
import { BaseMessage } from "../../interfaces/messages.type";
import { AppDispatch } from "../../store/store";
import { setMessages } from "../../store/slices/messages.slice";
import { useMutation } from "react-query";
import { api } from "@data-phone/react-resource-server-auth";
interface messagesQuery {
  did: string;
  conversation_id: string;
  limit: number;
  offset: number;
  account?: string | null;
}

const fetchData = async (
  query: messagesQuery,
  dispatch: AppDispatch
): Promise<{ messages: BaseMessage[], offset: number }> => {
  const params = new URLSearchParams({
    did: query.did,
    conversation_id: query.conversation_id,
    limit: String(query.limit),
    offset: String(query.offset),
  });
  if (query.account) {
    params.set("account", query.account);
  }

  const response = await api.get(
    `${process.env.REACT_APP_SMS_API_URL}/sms/messages?${params.toString()}`
  );
  const messages = response.data || [];
  dispatch(setMessages(messages));

  return {
    messages,
    offset: query.offset,
  };
};

const useGetMessages = () => {
  const dispatch: AppDispatch = useDispatch();

  return useMutation<{ messages: BaseMessage[], offset: number }, Error, messagesQuery>((query) => fetchData(query, dispatch), { mutationKey: ["messages"] });

};

export default useGetMessages;
